import { render, staticRenderFns } from "./imagenModal.vue?vue&type=template&id=64210c9c&"
import script from "./imagenModal.vue?vue&type=script&lang=js&"
export * from "./imagenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports